export const ANY_FILE_ACCEPT = "";

const COMPOUND_EXTENSIONS = ["tar.gz", "tar.bz2", "tar.xz", "user.js"];

const imageExtensions = new Set([
  "ai",
  "apng",
  "avif",
  "bmp",
  "cr2",
  "dwg",
  "dxf",
  "eps",
  "gif",
  "heic",
  "heif",
  "ico",
  "indd",
  "jpeg",
  "jpg",
  "nef",
  "png",
  "psd",
  "raw",
  "sketch",
  "svg",
  "tif",
  "tiff",
  "webp",
  "xd",
]);

const videoExtensions = new Set([
  "3g2",
  "3gp",
  "avi",
  "flv",
  "m4v",
  "mkv",
  "mov",
  "mp4",
  "mpeg",
  "mpg",
  "ogv",
  "webm",
  "wmv",
]);

const audioExtensions = new Set([
  "aac",
  "aif",
  "aiff",
  "flac",
  "m4a",
  "mid",
  "midi",
  "mp3",
  "oga",
  "ogg",
  "opus",
  "wav",
  "weba",
  "wma",
]);

const metadataByExtension = {
  pdf: ["document", "Adobe Acrobat PDF", "PDF viewer", "file-pdf"],
  doc: ["document", "Microsoft Word document", "Microsoft Word", "file-word"],
  docx: ["document", "Microsoft Word document", "Microsoft Word", "file-word"],
  docm: ["document", "Microsoft Word macro document", "Microsoft Word", "file-word"],
  dot: ["document", "Microsoft Word template", "Microsoft Word", "file-word"],
  dotx: ["document", "Microsoft Word template", "Microsoft Word", "file-word"],
  pages: ["document", "Apple Pages document", "Apple Pages", "file-lines"],
  odt: ["document", "OpenDocument text", "LibreOffice Writer", "file-lines"],
  rtf: ["document", "Rich Text document", "Text editor", "file-lines"],
  txt: ["text", "Plain text file", "Text editor", "file-lines"],
  md: ["text", "Markdown document", "Markdown editor", "file-lines"],
  markdown: ["text", "Markdown document", "Markdown editor", "file-lines"],
  tex: ["text", "LaTeX document", "LaTeX editor", "file-lines"],
  xls: ["spreadsheet", "Microsoft Excel workbook", "Microsoft Excel", "file-excel"],
  xlsx: ["spreadsheet", "Microsoft Excel workbook", "Microsoft Excel", "file-excel"],
  xlsm: ["spreadsheet", "Microsoft Excel macro workbook", "Microsoft Excel", "file-excel"],
  xlt: ["spreadsheet", "Microsoft Excel template", "Microsoft Excel", "file-excel"],
  xltx: ["spreadsheet", "Microsoft Excel template", "Microsoft Excel", "file-excel"],
  csv: ["spreadsheet", "CSV spreadsheet", "Spreadsheet app", "file-csv"],
  tsv: ["spreadsheet", "TSV spreadsheet", "Spreadsheet app", "file-csv"],
  ods: ["spreadsheet", "OpenDocument spreadsheet", "LibreOffice Calc", "file-excel"],
  numbers: ["spreadsheet", "Apple Numbers spreadsheet", "Apple Numbers", "file-excel"],
  ppt: ["presentation", "Microsoft PowerPoint deck", "Microsoft PowerPoint", "file-powerpoint"],
  pptx: ["presentation", "Microsoft PowerPoint deck", "Microsoft PowerPoint", "file-powerpoint"],
  pptm: ["presentation", "Microsoft PowerPoint macro deck", "Microsoft PowerPoint", "file-powerpoint"],
  pot: ["presentation", "Microsoft PowerPoint template", "Microsoft PowerPoint", "file-powerpoint"],
  potx: ["presentation", "Microsoft PowerPoint template", "Microsoft PowerPoint", "file-powerpoint"],
  odp: ["presentation", "OpenDocument presentation", "LibreOffice Impress", "file-powerpoint"],
  key: ["presentation", "Apple Keynote presentation", "Apple Keynote", "file-powerpoint"],
  zip: ["archive", "ZIP archive", "Archive utility", "file-zipper"],
  rar: ["archive", "RAR archive", "Archive utility", "file-zipper"],
  "7z": ["archive", "7-Zip archive", "Archive utility", "file-zipper"],
  tar: ["archive", "TAR archive", "Archive utility", "file-zipper"],
  gz: ["archive", "Gzip archive", "Archive utility", "file-zipper"],
  tgz: ["archive", "Gzip TAR archive", "Archive utility", "file-zipper"],
  bz2: ["archive", "Bzip2 archive", "Archive utility", "file-zipper"],
  xz: ["archive", "XZ archive", "Archive utility", "file-zipper"],
  "tar.gz": ["archive", "Gzip TAR archive", "Archive utility", "file-zipper"],
  "tar.bz2": ["archive", "Bzip2 TAR archive", "Archive utility", "file-zipper"],
  "tar.xz": ["archive", "XZ TAR archive", "Archive utility", "file-zipper"],
  dmg: ["archive", "Apple disk image", "Disk Utility", "hard-drive"],
  iso: ["archive", "Disk image", "Disk utility", "compact-disc"],
  html: ["code", "HTML document", "Web browser / code editor", "file-code"],
  htm: ["code", "HTML document", "Web browser / code editor", "file-code"],
  css: ["code", "CSS stylesheet", "Code editor", "file-code"],
  scss: ["code", "Sass stylesheet", "Code editor", "file-code"],
  sass: ["code", "Sass stylesheet", "Code editor", "file-code"],
  js: ["code", "JavaScript file", "Code editor", "file-code"],
  jsx: ["code", "React JavaScript file", "Code editor", "file-code"],
  ts: ["code", "TypeScript file", "Code editor", "file-code"],
  tsx: ["code", "React TypeScript file", "Code editor", "file-code"],
  json: ["code", "JSON data file", "Code editor", "file-code"],
  xml: ["code", "XML document", "Code editor", "file-code"],
  yaml: ["code", "YAML document", "Code editor", "file-code"],
  yml: ["code", "YAML document", "Code editor", "file-code"],
  sql: ["code", "SQL script", "Database tool", "database"],
  py: ["code", "Python script", "Python", "file-code"],
  java: ["code", "Java source file", "Java", "file-code"],
  c: ["code", "C source file", "C compiler", "file-code"],
  h: ["code", "C/C++ header file", "Code editor", "file-code"],
  cpp: ["code", "C++ source file", "C++ compiler", "file-code"],
  cs: ["code", "C# source file", ".NET", "file-code"],
  go: ["code", "Go source file", "Go", "file-code"],
  rb: ["code", "Ruby script", "Ruby", "file-code"],
  php: ["code", "PHP script", "PHP", "file-code"],
  swift: ["code", "Swift source file", "Swift", "file-code"],
  kt: ["code", "Kotlin source file", "Kotlin", "file-code"],
  rs: ["code", "Rust source file", "Rust", "file-code"],
  sh: ["code", "Shell script", "Terminal", "terminal"],
  bat: ["code", "Windows batch file", "Command Prompt", "terminal"],
  ps1: ["code", "PowerShell script", "PowerShell", "terminal"],
  apk: ["package", "Android package", "Android", "mobile-screen-button"],
  ipa: ["package", "iOS app package", "iOS", "mobile-screen-button"],
  exe: ["package", "Windows executable", "Windows", "gears"],
  msi: ["package", "Windows installer", "Windows Installer", "gears"],
  pkg: ["package", "Installer package", "Installer", "gears"],
  deb: ["package", "Debian package", "Linux package manager", "box"],
  rpm: ["package", "RPM package", "Linux package manager", "box"],
  ics: ["calendar", "Calendar event", "Calendar app", "calendar-days"],
  eml: ["email", "Email message", "Email app", "envelope"],
  msg: ["email", "Outlook message", "Microsoft Outlook", "envelope"],
  vcf: ["contact", "Contact card", "Contacts app", "address-card"],
  epub: ["ebook", "EPUB book", "E-book reader", "book-open"],
  mobi: ["ebook", "Kindle book", "E-book reader", "book-open"],
  azw: ["ebook", "Kindle book", "Kindle", "book-open"],
  azw3: ["ebook", "Kindle book", "Kindle", "book-open"],
  sqlite: ["database", "SQLite database", "SQLite", "database"],
  db: ["database", "Database file", "Database tool", "database"],
  parquet: ["data", "Parquet data file", "Analytics tool", "database"],
  avro: ["data", "Avro data file", "Analytics tool", "database"],
  ndjson: ["data", "NDJSON data file", "Analytics tool", "database"],
  log: ["text", "Log file", "Log viewer", "file-lines"],
  pem: ["certificate", "PEM certificate/key", "Certificate manager", "key"],
  crt: ["certificate", "Certificate file", "Certificate manager", "certificate"],
  cer: ["certificate", "Certificate file", "Certificate manager", "certificate"],
  pfx: ["certificate", "Certificate bundle", "Certificate manager", "certificate"],
};

imageExtensions.forEach((extension) => {
  metadataByExtension[extension] =
    metadataByExtension[extension] || ["image", `${extension.toUpperCase()} image`, "Image viewer", "file-image"];
});

videoExtensions.forEach((extension) => {
  metadataByExtension[extension] =
    metadataByExtension[extension] || ["video", `${extension.toUpperCase()} video`, "Video player", "file-video"];
});

audioExtensions.forEach((extension) => {
  metadataByExtension[extension] =
    metadataByExtension[extension] || ["audio", `${extension.toUpperCase()} audio`, "Audio player", "file-audio"];
});

function decodeName(value) {
  const raw = `${value || ""}`.trim();
  if (!raw) return "";
  const withoutQuery = raw.split(/[?#]/)[0];
  const leaf = withoutQuery.split("/").pop() || withoutQuery;
  try {
    return decodeURIComponent(leaf);
  } catch (_) {
    return leaf;
  }
}

export function getFileExtension(...candidates) {
  const name = candidates.map(decodeName).find(Boolean) || "";
  const lower = name.toLowerCase();
  for (const extension of COMPOUND_EXTENSIONS) {
    if (lower.endsWith(`.${extension}`)) return extension;
  }
  const match = lower.match(/\.([a-z0-9][a-z0-9+-]{0,31})$/i);
  return match ? match[1] : "";
}

function inferKindFromMime(contentType) {
  const type = `${contentType || ""}`.trim().toLowerCase();
  if (type.startsWith("image/")) return "image";
  if (type.startsWith("video/")) return "video";
  if (type.startsWith("audio/")) return "audio";
  if (type.includes("pdf")) return "document";
  if (type.includes("spreadsheet") || type.includes("excel") || type.includes("csv")) return "spreadsheet";
  if (type.includes("presentation") || type.includes("powerpoint")) return "presentation";
  if (type.includes("word") || type.includes("document") || type.includes("rtf")) return "document";
  if (type.includes("zip") || type.includes("compressed") || type.includes("archive")) return "archive";
  if (type.includes("json") || type.includes("xml") || type.includes("javascript")) return "code";
  if (type.startsWith("text/")) return "text";
  return "file";
}

function iconForKind(kind) {
  if (kind === "image") return "file-image";
  if (kind === "video") return "file-video";
  if (kind === "audio") return "file-audio";
  if (kind === "spreadsheet") return "file-excel";
  if (kind === "presentation") return "file-powerpoint";
  if (kind === "document" || kind === "text") return "file-lines";
  if (kind === "archive") return "file-zipper";
  if (kind === "code") return "file-code";
  return "file";
}

function meaningful(value, genericValues = []) {
  const normalized = `${value || ""}`.trim();
  if (!normalized) return "";
  return genericValues.includes(normalized.toLowerCase()) ? "" : normalized;
}

export function getFileTypeMetadata(input = {}) {
  const extension = `${input.extension || getFileExtension(input.name, input.originalName, input.url)}`.toLowerCase();
  const known = extension ? metadataByExtension[extension] : null;
  const rawType = `${input.type || input.contentType || ""}`.trim().toLowerCase();
  const typeKind =
    rawType === "image" || rawType.startsWith("image/")
      ? "image"
      : rawType === "video" || rawType.startsWith("video/")
        ? "video"
        : rawType === "audio" || rawType.startsWith("audio/")
          ? "audio"
          : "";
  const fileKind =
    known?.[0] ||
    meaningful(input.fileKind || input.kind, ["file"]) ||
    typeKind ||
    inferKindFromMime(input.contentType || input.type) ||
    "file";
  const icon = known?.[3] || meaningful(input.icon, ["file"]) || iconForKind(fileKind);
  const extensionLabel = extension ? extension.toUpperCase() : "";
  const appName =
    known?.[1] ||
    meaningful(input.appName, ["file", "attachment"]) ||
    (extensionLabel ? `${extensionLabel} file` : "File");
  const application =
    known?.[2] ||
    meaningful(input.application, ["system file handler", "file"]) ||
    (fileKind === "file" ? "System file handler" : appName);
  return {
    extension,
    fileKind,
    appName,
    application,
    icon,
    iconClass: input.iconClass || `fa-solid fa-${icon}`,
  };
}

export function inferAttachmentType(input = {}) {
  const rawType = `${input.type || ""}`.trim().toLowerCase();
  if (rawType === "voice_note" || rawType === "call_audio" || rawType === "call_video") {
    return rawType;
  }
  const metadata = getFileTypeMetadata(input);
  if (metadata.fileKind === "image") return "image";
  if (metadata.fileKind === "video") return "video";
  if (metadata.fileKind === "audio") return "audio";
  if (rawType === "image" || rawType === "video" || rawType === "audio") return rawType;
  return "file";
}

export function formatFileSize(bytes) {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value <= 0) return "";
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  if (value < 1024 * 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(1)} MB`;
  return `${(value / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
